import customIBCChannelListOfSourceChainAtomFamily from './atomFamily';

export default customIBCChannelListOfSourceChainAtomFamily;
